<template>
  <div class="content_main">
    <div class="left">
      <search-tree
        :treeData="deptTree"
        :dataList="dataList"
        :expandedKeys="expandedKeys"
        :holderText="holderText"
        @select="handleSelect"
      >
      </search-tree>
    </div>
    <div class="right">
      <div class="content_main_top">
        <a-input
          placeholder="请输入用户名"
          class="a_input_self margin_self"
          v-model="queryParam.userName"
          @keyup.enter.native="$refs.table.refresh(true)"
        />
        <a-input
          placeholder="请输入登录名"
          class="a_input_self margin_self"
          v-model="queryParam.loginName"
          @keyup.enter.native="$refs.table.refresh(true)"
        />
        <a-select
          placeholder="请选择状态"
          class="a_input_self margin_self"
          v-model="queryParam.status"
          @keyup.enter.native="$refs.table.refresh(true)"
        >
          <a-select-option :value="''">全部</a-select-option>
          <a-select-option :value="'0'">正常</a-select-option>
          <a-select-option :value="'1'">停用</a-select-option>
        </a-select>
        <a-input
          placeholder="请输入创建人"
          class="a_input_self margin_self"
          v-model="queryParam.createBy"
          @keyup.enter.native="$refs.table.refresh(true)"
        />
        <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
        <a-button style="margin-left: 8px" @click="() => (queryParam = {})">重置</a-button>
      </div>
      <div class="content_main_center_scroll" id="content_main_center_scroll">
        <s-table
          size="default"
          ref="table"
          rowKey="userId"
          :columns="columns"
          :data="loadData"
          :scroll="{ y: scroll_y }"
          defaultSort="createTime"
        >
          <span slot="action" slot-scope="text, record">
            <a @click="getRole(record)">角色信息</a>
          </span>
        </s-table>
      </div>
    </div>
    <a-modal class="gufiiguy" title="角色列表" :visible="roleVisible" @cancel="roleVisible = false" width="70%">
      <template slot="footer">
        <a-button key="back" @click="roleVisible = false"> 取消 </a-button>
      </template>
      <div style="margin: 20px">
        <a-table :data-source="roleList" bordered :pagination="false">
          <a-table-column key="roleName" title="角色名称" data-index="roleName" />
          <a-table-column key="remark" title="备注" data-index="remark" />
          <a-table-column title="操作">
            <template slot-scope="text, record">
              <a @click="editRole(record)">编辑</a>
            </template>
          </a-table-column>
        </a-table>
      </div>
    </a-modal>
    <a-modal
      class="gufiiguy"
      title="编辑角色权限"
      :visible="editVisible"
      @cancel="editVisible = false"
      width="50%"
      @ok="submit"
    >
      <div class="center">
        <div style="margin: 20px">
          <div>自定义审批权限：</div>
          <a-button key="back" type="primary" style="margin-top: 10px" @click="allSelect"> 全选 </a-button>
          <a-button key="back" type="primary" style="margin-top: 10px" @click="clearSelect"> 清除全部 </a-button>
        </div>
        <div>
          <a-tree
            checkable
            :autoExpandParent="autoExpandParent"
            v-model="checkedKeys2"
            :checkStrictly="checkStrictly"
            ref="rolestree"
            :treeData="deptTree2"
            @check="onCheck2"
          >
          </a-tree>
          <!-- <a-tree
			:checkStrictly="checkStrictly"
            :tree-data="deptTree2"
            show-icon
            default-expand-all
            :replace-fields="replaceFields"
            :expanded-keys="expandedKeys"
            :auto-expand-parent="autoExpandParent"
            checkable
            v-model="selectKey"
            @check="onCheck"
            @expand="onExpand"
          > -->
          <!-- <template slot="custom" slot-scope="item"> -->
          <!-- <span class="redd" v-if="item.title.indexOf(searchValue) > -1">
                {{ item.title.substr(0, item.title.indexOf(searchValue)) }}
                <span style="color: #f50">{{ searchValue }}</span>
                {{ item.title.substr(item.title.indexOf(searchValue) + searchValue.length) }}
              </span> -->
          <!-- <span v-else>{{ item.title }}</span> -->
          <!-- </template> -->
          <!-- </a-tree> -->
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
// import Quit from './Quit/index.vue'
import { STable, SearchTree } from '@/components'
import { getUserList, getDeptListEnable, getDeptList, authRoles, authDepts, authInfo } from '@/api/system'
// import UserModal from './modules/UserModal'
// import UserPwdModal from './modules/UserPwdModal'
export default {
  name: 'UserList',
  components: {
    SearchTree,
    STable,
    // UserModal,
    // UserPwdModal,
    // Quit
  },

  data() {
    return {
      checkStrictly: true,
      // checkedKeys: [],
      // replaceFields: {
      // 	title: 'title',
      // 	key: 'value',
      // 	children: 'children',
      // },
      // selectKey: [],
      roleId: '',
      userId: '',
      deptTree2: [],
      checkedKeys2: [],
      autoExpandParent: true,
      //角色权限列表
      limitList: [],
      editVisible: false,
      //角色列表
      roleList: [],
      roleVisible: false,
      mdl: {},
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '登录名',
          dataIndex: 'loginName',
        },
        {
          title: '用户名',
          width: '100px',
          dataIndex: 'userName',
        },
        {
          title: '邮箱',
          dataIndex: 'email',
        },
        {
          title: '创建人',
          dataIndex: 'createBy',
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          sorter: true,
        },
        {
          title: '更新人',
          dataIndex: 'updateBy',
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
          sorter: true,
        },

        {
          title: '操作',
          width: '240px',
          dataIndex: 'action',
          scopedSlots: {
            customRender: 'action',
          },
        },
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: (parameter) => {
        console.log('getloadDataPP')
        return getUserList(Object.assign(parameter, this.queryParam))
      },
      deptTree: [],
      expandedKeys: [],
      dataList: [],
      holderText: '搜索部门',
      selectedRowKeys: [],
      selectedRows: [],
      resettitle: '',
      rowData: '',
    }
  },
  created() {
    getDeptList().then((res) => {
      const data = res.rows
      if (data.length > 0) {
        const pids = data.map((m) => m.parentId)
        this.buildtree(data, this.deptTree2, Math.min(...pids))
        const pidSet = new Set(pids.map((m) => m + ''))
        this.pidSet = pidSet
        this.pidSet2 = pidSet
      }
    })
    getDeptListEnable().then((res) => {
      const data = res.rows
      // function slot(lis) {
      // 	lis.forEach((item) => {
      // 		item['scopedSlots'] = { icon: 'file-text', title: 'custom' }
      // 		if (item.children && item.children.length) {
      // 		slot(item.children)
      // 		}
      // 	})
      // }
      // slot(data)
      if (data.length > 0) {
        const min = Math.min(...data.map((m) => m.parentId))
        this.buildtree(data, this.deptTree, min)
        console.log(this.deptTree, 'sss')
        this.expandedKeys = data.map((m) => m.parentId)
        this.dataList = data.map((m) => {
          return {
            key: m.deptId,
            title: m.deptName,
          }
        })
      }
    })
  },
  mounted() {
    this.$nextTick(() => {
      var max_h = $('#content_main_center_scroll').height()
      this.scroll_y = max_h - 110
    })
  },

  methods: {
    // onExpand(expandedKeys) {
    // this.expandedKeys = expandedKeys
    // this.autoExpandParent = false
    // },
    //选择公司部门
    // onCheck(checkedKeys, e) {
    // this.selectKey = checkedKeys
    // console.log([...checkedKeys, ...e.halfCheckedKeys], 'checkedKeys====')
    // this.checkedKeys2 = [...checkedKeys, ...e.halfCheckedKeys]
    // },
    //清楚全部
    clearSelect() {
      this.checkedKeys2 = []
    },
    //全选
    allSelect() {
      console.log(this.deptTree2, 'deptTree2================')
      var ids = []
      this.deptTree2.forEach((item) => {
        ids.push(item.value)
        if (item.children) {
          item.children.forEach((item2) => {
            ids.push(item2.value)
            if (item2.children) {
              item2.children.forEach((item3) => {
                ids.push(item3.value)
              })
            }
          })
        }
      })
      this.checkedKeys2 = ids
    },
    //提交权限修改
    submit() {
      authInfo({
        userId: this.userId,
        roleId: this.roleId,
        deptIdList: this.checkedKeys2,
      }).then((res) => {
        if (res.code == 200) {
          this.editVisible = false
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    //选择权限
    onCheck2(checkedKeys, info) {
      // console.log(this.checkStrictly, 'this.checkStrictly===================')
      console.log(checkedKeys, '=================================')
      // console.log('onCheck', info)
      // if (!this.treeCheck2) this.treeCheck2 = true
      this.checkedKeys2 = checkedKeys.checked
    },
    //获取角色权限
    editRole(record) {
      this.roleId = record.roleId
      authDepts({
        userId: this.userId,
        roleId: record.roleId,
      }).then((res) => {
        if (res.code == 200) {
          this.checkedKeys2 = res.data
        }
      })
      this.editVisible = true
    },
    //获取角色列表
    getRole(record) {
      this.userId = record.userId
      authRoles({
        userId: record.userId,
      }).then((res) => {
        if (res.code == 200) {
          this.roleList = res.data
        }
      })
      this.roleVisible = true
    },
    onSelectChange(selectedRowKeys) {
      console.log('selectedRowKeys changed: ', selectedRowKeys)
      this.selectedRowKeys = selectedRowKeys
    },
    onChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    handleOk() {
      this.$refs.table.refresh()
      console.log('handleSaveOk')
    },
    buildtree(list, arr, parentId) {
      list.forEach((item) => {
        if (item.parentId === parentId) {
          var child = {
            key: item.deptId,
            value: item.deptId, // value是给modal的select用的，2者属性不一样
            title: item.deptName,
            scopedSlots: {
              title: 'title',
            },
            children: [],
          }
          this.buildtree(list, child.children, item.deptId)
          if (child.children.length === 0) {
            delete child.children
          }
          arr.push(child)
        }
      })
    },
    // 下面是树相关方法
    handleSelect(selectedKeys, info) {
      this.queryParam = {
        deptId: selectedKeys[0],
      }
      this.$refs.table.refresh(true)
    },
  },
  watch: {
    loadData() {
      console.log('refresh')
      this.$refs.table.refresh()
    },
    /*
			  'selectedRows': function (selectedRows) {
			    this.needTotalList = this.needTotalList.map(item => {
			      return {
			        ...item,
			        total: selectedRows.reduce( (sum, val) => {
			          return sum + val[item.dataIndex]
			        }, 0)
			      }
			    })
			  }
			  */
  },
}
</script>
<style scoped lang='less'>
.left {
  width: 20%;
  height: 100%;
  overflow-y: scroll;
  padding-right: 10px;
  float: left;
}

.right {
  width: 80%;
  height: 100%;
  float: left;
}
.center {
  display: flex;
  // justify-content: space-between;
}
</style>
